import { render, staticRenderFns } from "./SmartRating.vue?vue&type=template&id=6ef33b88&"
import script from "./SmartRating.vue?vue&type=script&lang=js&"
export * from "./SmartRating.vue?vue&type=script&lang=js&"
import style0 from "./SmartRating.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports